import type { PipeTransform } from '@angular/core';
import { Injectable, Pipe } from '@angular/core';

@Pipe({
  name: 'rtCurrency',
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class CurrencyPipe implements PipeTransform {
  public transform(amount: number, currency: string, fraction: number = 0): string {
    let symbol;
    let decimalSymbol;

    if (currency === 'EUR') {
      symbol = '€';
      decimalSymbol = ',';
    } else if (currency === 'USD') {
      symbol = '$';
    } else if (currency === 'GBP') {
      symbol = '£';
    }
    let amountString = `${amount.toFixed(fraction)}`;
    if (decimalSymbol) {
      amountString = amountString.replace('.', decimalSymbol);
    }

    return `${symbol}${amountString}`;
  }
}
